import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import { useGetAccountsByHTG, useGetSalesIds } from '../hooks/api/accounts'
import { useCreateUser } from '../hooks/api/users'
import AdminUserForm from '../components/admin/admin-user-form'
import { preprocessUserFormValues } from '../utils/formValues'
import { HTG_COMPANIES } from '../constants/companies'

const CreateUser = () => {
  const navigate = useNavigate()
  const [accounts, setAccounts] = useState({})
  const [initialValues] = useState({ configs: ['isActive'] })

  const { data: accs, isLoading: isLoadingAccount } = useGetAccountsByHTG(
    { htg: HTG_COMPANIES },
    {
      refetchOnWindowFocus: false,
    }
  )
  const { data: salesIds, isLoading: isLoadingSales } = useGetSalesIds({
    refetchOnWindowFocus: false,
  })

  const createUser = useCreateUser()
  const { enqueueSnackbar } = useSnackbar()

  useEffect(() => {
    if (_.isPlainObject(accs)) {
      setAccounts({ ...accounts, ...accs })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accs])

  const submitHandler = async (values) => {
    preprocessUserFormValues(values, accounts)

    const res = await createUser.mutateAsync(values)

    if (res?.status === 200) {
      enqueueSnackbar(`${values.email} is created`, {
        variant: 'success',
      })
    }
  }

  const onSubmit = (handleSubmit) => (event) => {
    handleSubmit(event)
      .then(() => navigate('/admin'))
      .catch((err) => {
        enqueueSnackbar(err?.response?.data?.message || 'Unknown error', {
          variant: 'error',
        })
      })
  }

  return (
    <AdminUserForm
      salesIds={salesIds}
      submitHandler={submitHandler}
      onSubmit={onSubmit}
      title='Create user'
      submitButtonText='Create'
      initialValues={initialValues}
      accounts={accounts}
      isLoadingAccount={isLoadingAccount}
      isLoadingSales={isLoadingSales}
    />
  )
}

export default CreateUser
